/**
 * SFB — Write a Review deep-link handler
 *
 * Auto-opens the branded "Write a Review" modal on any PDP when the URL
 * contains ?write-review=1, and optionally pre-fills the email field
 * when ?email=<address> is also passed.
 *
 * Shareable URL patterns:
 *   /products/<handle>?write-review=1
 *   /products/<handle>?write-review=1&email=customer@example.com
 *
 * How it opens the modal:
 *   This theme renders a branded modal (snippets/sfb-write-review-modal.liquid,
 *   element #sfb-wr-scrim) that listens for a CustomEvent('sfb:write-review:open')
 *   — see assets/sfb-write-review.js. We dispatch that event once the modal is
 *   in the DOM. A button-click fallback is kept in case the modal isn't present
 *   (e.g. a PDP template without the Reviews (SFB) section).
 *
 * Verified Buyer status:
 *   Judge.me marks a review "Verified Buyer" only when the submitted email
 *   matches a Shopify order containing the reviewed product. Use Shopify
 *   POS / Draft Orders for in-person sales so this match succeeds.
 */
(function () {
  'use strict';

  // Only run on product pages.
  if (!/^\/products\//.test(window.location.pathname)) return;

  var params = new URLSearchParams(window.location.search);
  if (!params.has('write-review')) return;

  var emailFromUrl = params.get('email');

  // Branded modal (primary path).
  var SCRIM_SELECTOR = '#sfb-wr-scrim';
  var EMAIL_INPUT_SELECTOR = '#sfb-wr-form input[name="email"]';

  // Fallback trigger buttons, only used if the branded modal isn't present.
  var FALLBACK_BUTTON_SELECTORS = [
    '[data-open-write-review]',
    '.jdgm-write-rev-link',
    'button[class*="write-review"]'
  ];

  function findFirst(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  // Resolve as soon as any of `selectors` is in the DOM, else reject on timeout.
  function waitFor(selectors, timeoutMs) {
    timeoutMs = timeoutMs || 10000;
    var list = typeof selectors === 'string' ? [selectors] : selectors;
    return new Promise(function (resolve, reject) {
      var existing = findFirst(list);
      if (existing) return resolve(existing);

      var observer = new MutationObserver(function () {
        var el = findFirst(list);
        if (el) {
          observer.disconnect();
          clearTimeout(timer);
          resolve(el);
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });

      var timer = setTimeout(function () {
        observer.disconnect();
        var late = findFirst(list);
        late ? resolve(late) : reject(new Error('timeout waiting for ' + list.join(',')));
      }, timeoutMs);
    });
  }

  function prefillEmail() {
    if (!emailFromUrl) return;
    var input = document.querySelector(EMAIL_INPUT_SELECTOR);
    if (!input || input.value) return; // don't overwrite anything the user typed
    input.value = emailFromUrl;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Clean the URL so a refresh doesn't re-open the modal.
  function clearParams() {
    var url = new URL(window.location.href);
    url.searchParams.delete('write-review');
    url.searchParams.delete('email');
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
  }

  function openViaEvent() {
    prefillEmail();
    document.dispatchEvent(new CustomEvent('sfb:write-review:open'));
    clearParams();
  }

  function openViaFallbackButton() {
    waitFor(FALLBACK_BUTTON_SELECTORS, 10000)
      .then(function (btn) {
        // Small delay lets any third-party JS finish wiring its click handler.
        setTimeout(function () {
          btn.click();
          clearParams();
        }, 250);
      })
      .catch(function (err) {
        console.warn('[SFB write-review deeplink]', err.message);
      });
  }

  function run() {
    // Prefer the branded modal; fall back to a trigger button if it's absent.
    waitFor(SCRIM_SELECTOR, 10000)
      .then(openViaEvent)
      .catch(openViaFallbackButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
